export type GoogleAnalyticsCommand =  'get' | 'set' | 'event' | 'consent' | 'js' | 'config';
export type GoogleAnalyticsDelegate = (command: GoogleAnalyticsCommand, ...commandParameters: any[]) => void;